import React from 'react';
import { Box, styled, useTheme } from '@mui/material';

const BadgeComponent = styled(Box)<{ borderColor: string; bgcolor: string }>(
  ({ borderColor, bgcolor, theme }) => ({
    margin: 'auto',
    borderLeft: `10px solid ${borderColor}`,
    background: bgcolor,
    display: 'flex',
    alignItems: 'center',
    width: 'fit-content',
    padding: '0.2em 1em',
    position: 'absolute',
    top: 0,
    left: 0,
    opacity: 0.8,
    color: theme.palette.primary.contrastText,
  })
);

const Badge = ({
  children,
  type = 'error',
  customColors,
}: {
  type?: 'error' | 'duplicated' | 'new' | string;
  children: React.ReactNode;
  customColors?: {
    [key: string]: {
      borderColor: string;
      bgColor: string;
    };
  };
}) => {
  const theme = useTheme();

  const colors = {
    error: {
      borderColor: theme.palette.error.dark,
      bgColor: theme.palette.error.main,
    },
    duplicated: {
      borderColor: theme.palette.warning.dark,
      bgColor: theme.palette.warning.main,
    },
    new: {
      borderColor: theme.palette.success.dark,
      bgColor: theme.palette.success.main,
    },
  };
  const mergedColors = { ...colors, ...customColors };
  const item = mergedColors[type as keyof typeof mergedColors];
  const border = item?.borderColor || '';

  const bgColor = item?.bgColor || '';
  return (
    <BadgeComponent borderColor={border} bgcolor={bgColor}>
      {children}
    </BadgeComponent>
  );
};

export default Badge;
